import * as Sentry from '@sentry/browser';
import useUserManager from '@ers/authorization/userManager';

function shouldBeIgnored(error) {
    const messages = [
        'OidcClient.readSigninResponseState: No state in response',
        'OidcClient.readSigninResponseState: No matching state found in storage',
        'Frame window timed out'
    ];

    const isErrorFromArray = messages.includes(error.message);

    return isErrorFromArray || /CheckSessionIFrame|Loading chunk/.test(error.message);
}

function shouldBeLogAsWarning(error) {
    const msg = error.message || error;
    const messages = [
        'JsonService.postForm: Error from server: ',
        'invalid_grant',
        'Network Error',
        'JsonService.getJson: network error',
        'SilentRenewService._tokenExpiring: Error from signinSilent:',
    ];

    if (msg === undefined) {
        return false;
    }

    const isErrorFromArray = messages.includes(msg);
    return isErrorFromArray;
}

function shouldResignin(error) {
    const messages = [
        'JsonService.postForm: Error from server: ',
        'invalid_grant',
        'Network Error',
        'JsonService.getJson: network error',
    ];
    const isErrorFromArray = messages.includes(error.message);

    return isErrorFromArray;
}
const SentryLogger = {
    // eslint-disable-next-line no-console
    debug: console.debug,
    info: (e) => {
        Sentry.withScope((scope) => {
            scope.setLevel('info');
            Sentry.captureException(e);
        });
    },
    warn: (e) => {
        Sentry.withScope((scope) => {
            scope.setLevel('warning');
            Sentry.captureException(e);
        });
    },
    error: (e) => {
        try {
            if (shouldBeIgnored(e)) {
                return;
            }
            if (shouldBeLogAsWarning(e)) {
                Sentry.withScope((scope) => {
                    scope.setLevel('warning');
                    scope.setTag('sr', sessionStorage.getItem('SR'));
                    Sentry.captureException(`OIDC logger warning: ${e.message} ${e}`);
                });
            } else {
                Sentry.withScope((scope) => {
                    scope.setLevel('error');
                    scope.setTag('sr', sessionStorage.getItem('SR'));
                    Sentry.captureException(e);
                });
            }
            if (shouldResignin(e)) {
                useUserManager().signinRedirect({ data: window.location.origin });
                return;
            }
        } catch (error) {
            Sentry.captureException(error);
        }
    }
};
export default SentryLogger;

export function beforeSendSentry(event) {
    try {
        const isChromeExtension = event.exception.values.some(
            (val) => val.stacktrace.frames.some(
                (frame) => frame.filename.startsWith('chrome-extension')
            )
        );
        if (isChromeExtension) {
            return null;
        }
        return event;
    } catch (e) {
        return event;
    }
}